import axios from "axios";
import { reactive, onMounted } from "vue";

// Define a reactive state to store request count
const state = reactive({
  requestCount: 0,
});

// Fetch request count from API
const fetchRequestCount = async () => {
  try {
    const response = await axios.get(
      "https://wossdb.wossautoid.com/api/requestCount"
    );
    state.requestCount = response.data.data;
  } catch (error) {
    console.error("Error fetching request count:", error);
  }
};

// Get user role from local storage
const type = localStorage.getItem("type");

// Menu items structure
const menuItems = reactive([
  {
    id: "/dashboard",
    title: "Dashboard",
    iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M8.97 22h6c5 0 7-2 7-7V9c0-5-2-7-7-7h-6c-5 0-7 2-7 7v6c0 5 2 7 7 7Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="m1.97 12.7 6-.02c.75 0 1.59.57 1.87 1.27l1.14 2.88c.26.65.67.65.93 0l2.29-5.81c.22-.56.63-.58.91-.05l1.04 1.97c.31.59 1.11 1.07 1.77 1.07h4.06" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>`,
    navLink: "/dashboards",
  },
  {
    id: "wcc",
    title: "WCC",
    icon: "Curved-Activity",
    navLink: "https://wcc.woss911.com/",
    target: "_blank",
    noTranslate: true,
  },
]);

// Add menu items dynamically based on user role
if (type === "super_admin" || type === "manager" || type === "employee") {
  menuItems.push({
    id: "pending",
    title: `Pending User`,
    icon: "Curved-Graph",
    children: [
      {
        id: "view-request",
        title: "View Pending",
        navLink: "/request/list",
      },
    ],
  });
}


// Add other menu sections
const additionalMenuItems = [
  {
    id: "user",
    title: "User",
    icon: "Curved-AddUser",
    children: [
      {
        id: "list-user",
        title: "List User",
        navLink: "/view/list/user",
      },
      // {
      //   id: "list-company",
      //   title: "List Company",
      //   navLink: "/view/list/company",
      // },
    ],
  },
  {
    id: "stakeholder",
    title: "Stakeholder",
    icon: "Curved-AddUser",
    children: [
      {
        id: "add-stakeholder",
        title: "Add Stakeholder",
        navLink: "/add/stakeholder",
      },
      {
        id: "list-stakeholder",
        title: "List Stakeholder",
        navLink: "/list/stakeholder",
      },
    ],
  },
    // User Management code here
      {
      id: "UserManagement",
      title: "User Management",
      icon: "Curved-AddUser",
      children: [
        {
          id: "UserManagement",
          title: "Add Manager",
          navLink: "/add/user",
        },
        {
          id: "UserManagement",
          title: "List Manager",
          navLink: "/list/user",
        },
        //  {
        //   id: "Agent",
        //   title: "Add Agent",
        //   navLink: "/add/agent",
        // },
        //  {
        //   id: "Agent",
        //   title: "List Agent",
        //   navLink: "/list/agent",
        // },
      ],
    },
  {
    id: "vehicle",
    title: "Vehicle",
    icon: "Curved-TicketStar",
    children: [
      { id: "add-vehicle", title: "Add Vehicle", navLink: "/add/vehicle" },
      { id: "list-vehicle", title: "List Vehicle", navLink: "/list/vehicle" },
      { id: "list-theft", title: "List Theft", navLink: "/list/theft" },
      {
        id: "recover-vehicle",
        title: "Recover Vehicle",
        navLink: "/recover/vehicle/theft/list",
      },
    ],
  },
  {
    id: "category",
    title: "Vehicle Categories",
    icon: "Curved-Document",
    children: [
      { id: "add-category", title: "Add Category", navLink: "/add/category" },
      { id: "list-category", title: "List Category", navLink: "/list/category" },
    ],
  },
  {
    id: "brand",
    title: "Vehicle Brands",
    icon: "Curved-Discount",
    children: [
      { id: "add-brand", title: "Add Brand", navLink: "/add/brand" },
      { id: "list-brand", title: "List Brand", navLink: "/list/brand" },
    ],
  },
  {
    id: "model",
    title: "Vehicle Model",
    icon: "Curved-Paper",
    children: [
      { id: "add-model", title: "Add Model", navLink: "/add/model" },
      { id: "list-model", title: "List Model", navLink: "/list/model" },
    ],
  },
   // Insurance company code here 
   {
    id: "insurance-company",
    title: "Business Partner",
    icon: "Curved-Message",
    children: [
      {
        id: "add-insurance-company",
        title: "Add Business Partner",
        navLink: "/add/insurance/company",
      },
      {
        id: "list-insurance-company",
        title: "List Business Partner",
        navLink: "/list/insurance/company",
      },
    ],
  },
   // MarketPlace code here 
   {
    id: "marketplace",
    title: "MarketPlace",
    icon: "Curved-InfoSquare",
    children: [
      {
        id: "add-marketplace",
        title: "Add MarketPlace",
        navLink: "/add/marketplace",
      },
      {
        id: "list-marketplace",
        title: "List MarketPlace",
        navLink: "/list/marketplace",
      },
    ],
  },
     // Slider code here 
     {
      id: "slider",
      title: "Slider",
      icon: "Curved-Discovery",
      children: [
        {
          id: "add-slider",
          title: "Add Slider",
          navLink: "/add/slider",
        },
        {
          id: "list-slider",
          title: "List Slider",
          navLink: "/list/slider",
        },
      ],
    },
    // Police code here 
    {
      id: "police",
      title: "Police",
      icon: "Curved-AddUser",
      children: [
        {
          id: "add-police",
          title: "Add Police",
          navLink: "/add/police",
        },
        {
          id: "list-police",
          title: "List Police",
          navLink: "/list/police",
        },
      ],
    },
  {
    id: "notification",
    title: "Notification",
    icon: "Curved-Notification",
    children: [
      {
        id: "detail-notification",
        title: "Detail Notification",
        navLink: "/notification/detail",
      },
      {
        id: "send-notification",
        title: "Send Notification",
        navLink: "/send/notification",
      },
    ],
  },
     // Inspection Location code here 
     {
      id: "inspection-location",
      title: "Inspection Location",
      icon: "Curved-EditSquare",
      children: [
        {
          id: "add-inspection-location",
          title: "Add Inspection Location",
          navLink: "/add/branch",
        },
        {
          id: "list-inspection-location",
          title: "List Inspection Location",
          navLink: "/list/branch",
        },
      ],
    },
    // Schedule code here 
    {
      id: "schedule",
      title: "Schedule",
      icon: "Curved-Filter2",
      children: [
        {
          id: "list-schedule",
          title: "List Schedule",
          navLink: "/list/schedule",
        },
      ],
    },
    // ............................... 
     // Product code here 
     {
      id: "Product",
      title: "Product",
      icon: "Curved-EditSquare",
      children: [
        {
          id: "Product",
          title: "Add Product",
          navLink: "/add/product",
        },
        {
          id: "Product",
          title: "List Product",
          navLink: "/list/product",
        },
      ],
    },
      // Order  code here 
      {
        id: "Order",
        title: "Order",
        icon: "Curved-Document",
        children: [
          {
            id: "Order",
            title: "List Order",
            navLink: "/list/order",
          },
        ],
      },
      
      // Tracker  code here 
  {
    id: "tracker",
    title: "Tracker",
    icon: "Curved-EditSquare",
    children: [
      { id: "list-tracker", title: "List Tracker", navLink: "/list/tracking" },
      {
        id: "stolen-tracker",
        title: "Stolen List Tracker",
        navLink: "/list/tracking/stolen",
      },
    ],
  },

    // OwnerShip  code here 
    {
      id: "OwnerShip",
      title: "OwnerShip",
      icon: "Curved-EditSquare",
      children: [

        {
          id: "OwnerShip",
          title: "List OwnerShip",
          navLink: "/list/ownership",
        },

      
      ],
    },
     {
      id: "SupportAgent",
      title: "Support Agent",
      icon: "Curved-AddUser",
      children: [
         {
          id: "Agent",
          title: "Add Agent",
          navLink: "/add/agent",
        },
         {
          id: "Agent",
          title: "List Agent",
          navLink: "/list/agent",
        },
      ],
    },
    {
    id: "expense",
    title: "Expense",
    icon: "Curved-EditSquare",
    children: [
      {
        id: "add-expense",
        title: "Add Expense",
        navLink: "/add/Expense",
      },
      {
        id: "list-expense",
        title: "List Expense",
        navLink: "/list/expense",
      },
    ],
  },
  {
    id: "reports",
    title: "Reports",
    icon: "Curved-Graph",
    children: [
      {
        id: "earnings-report",
        title: "Earnings Report",
        navLink: "/report/earnings",
      },
      // {
      //   id: "overall-report",
      //   title: "Overall Report",
      //   navLink: "/report/overall",
      // },
    ],
  },
];

// Add additional menu items to the menu
menuItems.push(...additionalMenuItems);

// Fetch data when the component mounts
onMounted(() => {
  fetchRequestCount();
});

// Export menu structure
export default {
  children: menuItems,
};
